import { ApolloProvider } from '@apollo/client';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import {
  AdviceProvider,
  DialogDisplay,
  DialogProvider,
  GoogleAuthProvider,
  MenuDisplay,
  MenuProvider,
  NotificationDisplay,
  NotificationProvider,
  UpdateNotification,
} from '@prismamedia/one-components';
import { setDefaultOptions } from 'date-fns';
import { fr } from 'date-fns/locale';
import frLocale from 'date-fns/locale/fr';
import moment from 'moment';
import 'moment/locale/fr';
import { FC } from 'react';
import { ApolloProvider as OldApolloProviderForOneCrud } from 'react-apollo';
import { initialize } from 'react-ga';
import { BrowserRouter, Route } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { QueryParamProvider } from 'use-query-params';
import { client } from './apollo';
import { Routing } from './routing';
import { useStyles } from './styles';
import { theme } from './theme';

const isStagingBrancheEnv = (location: string): boolean =>
  Boolean(location.match(/^\/branches\//));

moment.locale('fr');
setDefaultOptions({ locale: fr });

initialize(config.GA_ID, {
  testMode: process.env.NODE_ENV === 'test',
});

// TODO Remove crud: remove apollo-client & react-apollo packages, delete <OldApolloProviderForOneCrud>
export const App: FC = () => {
  const classes = useStyles();

  // Rewrite the base path to handle the deployment of staging branches
  const baseName = isStagingBrancheEnv(window.location.pathname)
    ? window.location.pathname.split('/').slice(1, 3).join('/')
    : '/';

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <RecoilRoot>
          <CssBaseline>
            <GoogleAuthProvider>
              <ApolloProvider client={client}>
                <OldApolloProviderForOneCrud client={client as any}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={frLocale}
                  >
                    <BrowserRouter basename={baseName}>
                      <QueryParamProvider ReactRouterRoute={Route}>
                        <AdviceProvider>
                          <DialogProvider>
                            <NotificationProvider>
                              <MenuProvider>
                                <div
                                  className={`${classes.printPortalWrapper} print-portal-wrapper`}
                                />
                                <div className={classes.appContainer}>
                                  <Routing />
                                  <UpdateNotification />
                                  <MenuDisplay />
                                  <NotificationDisplay />
                                  <DialogDisplay />
                                </div>
                              </MenuProvider>
                            </NotificationProvider>
                          </DialogProvider>
                        </AdviceProvider>
                      </QueryParamProvider>
                    </BrowserRouter>
                  </LocalizationProvider>
                </OldApolloProviderForOneCrud>
              </ApolloProvider>
            </GoogleAuthProvider>
          </CssBaseline>
        </RecoilRoot>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
